import { DailyCheckInClaim, DailyCheckInClaimBonusInput } from '@apeiron/reward'
import { deserializeListData, MayNull } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { dailyCheckInClaimSchema } from '@src/deserialize/yup/reward'
import graphql from '@src/graphql/mutation/claimDailyCheckInBonus'
import { useCallback, useState } from 'react'

const useClaimDailyCheckInBonus = (): Hook => {
  const [claimDailyCheckInBonus, { loading }] = useMutation(graphql)

  const [data, setData] = useState<MayNull<Response>>(null)

  const mutate = useCallback(
    async (input: DailyCheckInClaimBonusInput[]): Promise<Response> => {
      const response = await claimDailyCheckInBonus({
        variables: {
          input: {
            claimData: input
          }
        }
      })

      const deserialized = deserializeListData<DailyCheckInClaim>(
        response,
        dailyCheckInClaimSchema
      )

      setData(deserialized[0])

      return deserialized[0]
    },
    [claimDailyCheckInBonus]
  )

  return {
    data,
    loading,
    mutate
  }
}

type Response = MayNull<DailyCheckInClaim>

type Hook = {
  data: MayNull<DailyCheckInClaim>
  loading: boolean
  mutate: (input: DailyCheckInClaimBonusInput[]) => Promise<Response>
}

export default useClaimDailyCheckInBonus
